import { rem, stripUnit } from 'polished'
import { desktopCSS, layout, mobileCSS, tabletCSS } from '@measures/responsive'
import { css } from 'styled-components'

const base = {
  // default gutter sizes for grid
  gutters: {
    horizontal: '10px',
    vertical: '10px',
  },

  // spacings
  spacing: {
    atomHorizontal: '6px',
    atomVertical: '10px',
    minimum: '2px', // borders and ad spacing
    horizontalDesktop: '35px',
    horizontalTablet: '78px',
    horizontalMobile: '12px',
  },

  // article content
  content: {
    paddingLeft: '40px',
    paddingRight: '40px',
    paddingTablet: '72px',
    paddingMobile: '12px',
    defaultMargin: '32px',
    textMargin: '16px',
  },

  // navigation bar dimensions
  navigationBar: {
    sectionHeight: '38px',
    iconSize: '32px',
    level1Height: '60px',
    level2Height: '60px',
    level1HeightMobile: '48px',
  },

  mainMenu: {
    itemHeightMobile: '40px',
  },

  // button size for carousels
  buttonSize: '30px',

  // ads
  ads: {
    exclusionZone: '6px',
    flagHeight: '11px',
    flagWidth: '50px',
    minWidth: '200px', // minimum width, ...
    maxWidth: '300px', // maximum width of floating ads (Skyscraper, HalfPage)
  },

  // playlist
  playlist: {
    height: '369px',
    width: '304px',
  },

  // be careful
  ratios: {
    '21_9': {
      name: '21_9',
      width: 21,
      height: 9,
    },
    '16_9': {
      name: '16_9',
      width: 16,
      height: 9,
    },
    '6_5': {
      name: '6_5',
      width: 6,
      height: 5,
    },
    '3_2': {
      name: '3_2',
      width: 3,
      height: 2,
    },
    '1_1': {
      name: '1_1',
      width: 1,
      height: 1,
    },
    '4_3': {
      name: '4_3',
      width: 4,
      height: 3,
    },
    free: {
      name: 'free',
      width: 'auto',
      height: 'auto',
    },
  },
}

// adds up pixel and number values alike, returns a number.
type NumberOrPixelValue = string | number
type RemValue = string

const sum = (...args: NumberOrPixelValue[]): number =>
  args.reduce<number>((acc, curr) => acc + Number(stripUnit(curr)), 0)

const remSum = (...args: NumberOrPixelValue[]): RemValue =>
  rem(sum(...args) + 'px')

const stretch = (direction: 'left' | 'right', fullwidth?: boolean) => css`
  ${desktopCSS(css`
    // 994px - desktop content width, 576px - element width
    margin-${direction}: ${fullwidth ? 'calc((576px - 994px) / 2)' : '-40px'};
  `)}
  ${tabletCSS(css`
    margin-${direction}: -72px;
  `)}
  ${mobileCSS(css`
    margin-${direction}: -12px;
  `)}
`

const stretchToFitCard = (direction: 'left' | 'right') => css`
    margin-${direction}: -32px;
  ${mobileCSS(css`
    margin-${direction}: -24px;
  `)}
`

const shrinkToFit = (direction: 'left' | 'right') => css`
  ${desktopCSS(css`
    margin-${direction}: 40px;
  `)}
  ${tabletCSS(css`
    margin-${direction}: 72px;
  `)}
  ${mobileCSS(css`
    margin-${direction}: 12px;
  `)}
`

const exports = {
  ...base,
  page: {
    mainContainerWidth:
      sum(layout.desktop.minWidth, base.ads.exclusionZone, base.ads.maxWidth) +
      'px',
  },
  // utils
  stretch,
  stretchToFitCard,
  shrinkToFit,
  sum,
  remSum,
}

export default exports
